import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { loadAllWeeks } from "../../lib/api/week";
//import { EmptyBlank } from "../../components/common";
import { WeekHomeForm } from "../../components/week/WeekHomeForm";

const Home = () => {
  const navigate = useNavigate();
  const [weeks, setWeeks] = useState();

  const requestLoadAllWeeks = useCallback(async () => {
    const { data } = await loadAllWeeks();
    setWeeks(data);
    //console.log(data);
  }, []);

  useEffect(() => {
    requestLoadAllWeeks();
  }, [requestLoadAllWeeks]);

  const handleDetail = (e) => {
    navigate(`/weeks/${e.target.value}`);
  };

  return (
    <div>
      <Container fluid="md">
        <WeekHomeForm weeks={weeks} handleDetail={handleDetail} />
      </Container>
    </div>
  );
};

export default Home;
